import React, { useState, useEffect, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Header, SideBar } from 'CommonComponent';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

const useStyles = createUseStyles({
  userTable: {
    paddingRight: '24px',
  },
});

const DashboardLayout = () => {

  const themeState = useSelector(state => state.themeState);

  useEffect(() => {
    document.body.setAttribute('data-theme', themeState.themeMode);
  }, [themeState.themeMode]);

  const classes = useStyles();

  return (
    <>
      <Header />
      <div className={`d-flex ${classes.userTable}`}>
        <SideBar /> {/* Pass theme to SideBar */}
        <div className="content-area">
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
